import '../styles/about.css';

const About = () => {
  return (
    <div className="section wrapper">
      <div className="section-content" id="about">
        <div className="center-content">
          <img className="profile" src="profile.jpeg" alt="profile" />
          <div className="about-text ">
   
            <p >
              I find immense joy in the art of coding and problem-solving. Programming allows me to constantly explore new possibilities and push the boundaries of what's possible. It's the perfect blend of logic and creativity, enabling me to build efficient solutions.
            </p>
          
            <p>
              Outside of work, I have a curious spirit that drives me to explore
              various interests and pursuits. I find joy in immersing myself in
              nature, whether it's going for long hikes, capturing breathtaking
              landscapes through photography, or simply finding peace in the
              tranquility of the outdoors.
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
